export const REVIEW_RATING_FETCH_SIZE = '10000';

export type ReviewWithRanking = {
  ranking: number;
  user: { id?: string };
  stage?: string;
  removalReason?: unknown;
};

export const resolveMyReview = <T extends ReviewWithRanking>(
  mine: T | undefined,
): T | undefined => {
  if (!mine) return undefined;
  if (mine.stage === 'Inactive' && !mine.removalReason) return undefined;
  return mine;
};

export const buildReviewsForRating = <T extends ReviewWithRanking>(
  reviews: T[],
  myReview: T | undefined,
  userId: string | undefined,
): T[] => {
  const filtered = userId ? reviews.filter(review => review.user.id !== userId) : reviews;
  if (!myReview) return filtered;
  return [myReview, ...filtered];
};

export const calculateProductReviewRating = (reviews: { ranking: number }[]) => {
  if (!reviews.length) return { average: 0, count: 0 };

  const average = reviews.reduce((sum, review) => sum + review.ranking, 0) / reviews.length;
  return { average, count: reviews.length };
};
